<template>
  <FormEducation
    form-type="EducationForm"
    v-bind="widget"
    :message-placeholder="t('form.message-needs.placeholder')"
  />
</template>

<script lang="ts" setup>
import type { PublicContactFormWidget } from '@/service/__generated-api'
import type { Widget } from '@/types/utils'

defineProps<Widget<PublicContactFormWidget>>()

const { t } = useI18n()
</script>
